import { ComplexEnum } from '../../utils/complexEnum'
import {
  DailyInspectionInspection,
  AsphaltLot,
  ConcreteTest,
  DailyInspectionControlPoint,
  DailyInspectionPunchList,
  DensityTest,
  Lot,
} from './instances'

export type IFIReportTypeItem =
  | typeof DailyInspectionInspection
  | typeof AsphaltLot
  | typeof ConcreteTest
  | typeof DailyInspectionControlPoint
  | typeof DailyInspectionPunchList
  | typeof DensityTest
  | typeof Lot

class IFIReportTypeEnum extends ComplexEnum<
  'IFIReportType',
  IFIReportTypeItem,
  IFIReportTypeItem['id']
> {
  readonly typename = 'IFIReportType'
  get values() {
    return [
      this.DailyInspectionInspection,
      this.AsphaltLot,
      this.ConcreteTest,
      this.DailyInspectionControlPoint,
      this.DailyInspectionPunchList,
      this.DensityTest,
      this.Lot,
    ]
  }
  get classTypes() {
    return [...new Set(this.map(({ classType }) => classType))]
  }
  readonly DailyInspectionInspection = DailyInspectionInspection
  readonly AsphaltLot = AsphaltLot
  readonly ConcreteTest = ConcreteTest
  readonly DailyInspectionControlPoint = DailyInspectionControlPoint
  readonly DailyInspectionPunchList = DailyInspectionPunchList
  readonly DensityTest = DensityTest
  readonly Lot = Lot
}

export const IFIReportType = new IFIReportTypeEnum()
